import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.c5h().w50() : headers;
  return DelegatedCall().v5i(_this__u8e3s4.x5g_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      static v5i(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.c5h().w50() : responseHeaders;
        var $this = this.w5i(client);
        $this.z5g_1 = new (DelegatedRequest())($this, originCall.x5i());
        $this.a5h_1 = new (DelegatedResponse())($this, originCall.c5h(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.c5j_1 = origin;
        this.d5j_1 = call;
      }
      e5j() {
        return this.d5j_1;
      }
      sv() {
        return this.c5j_1.sv();
      }
      f5j() {
        return this.c5j_1.f5j();
      }
      g5j() {
        return this.c5j_1.g5j();
      }
      y5i() {
        return this.c5j_1.y5i();
      }
      e2o() {
        return this.c5j_1.e2o();
      }
      w50() {
        return this.c5j_1.w50();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.w50() : headers;
        super();
        this.h5j_1 = call;
        this.i5j_1 = origin;
        this.j5j_1 = content;
        this.k5j_1 = headers;
        this.l5j_1 = this.i5j_1.sv();
      }
      e5j() {
        return this.h5j_1;
      }
      w50() {
        return this.k5j_1;
      }
      m5j() {
        return this.j5j_1(this.i5j_1);
      }
      sv() {
        return this.l5j_1;
      }
      n5j() {
        return this.i5j_1.n5j();
      }
      o5j() {
        return this.i5j_1.o5j();
      }
      p5j() {
        return this.i5j_1.p5j();
      }
      q5j() {
        return this.i5j_1.q5j();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
